import { orderCancel } from './order-cancel-en.i18n';

export const en = {
  orderCancel,
};
